import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderRateReasonEntity } from '../../domain/entities/OrderRateReasonEntity'
import type { UserOrderRateReasonAdminDto } from '@/backend/market'

export class OrderRateReasonModel extends OrderRateReasonEntity {
  channelId?: number
  channelName?: string | null
  constructor(dataDto: UserOrderRateReasonAdminDto) {
    super()
    mapEntityProperties<OrderRateReasonEntity>(this, dataDto, {
      map: {
        channel: {
          id: dataDto.channelId,
          name: dataDto.channelName
        }
      }
    })
  }
}
